export class EnclosureTypesNamesConstants {
  public static PRISMA_XS = 'PrismaXS';
  public static PRAGMA_MULTI_UP = 'PragmaMultiUP';
}
